import {
  defineComponent,
  ref,
} from 'vue';
import { VAutocomplete } from 'vuetify/components';
import { ApiConsentClient } from '@src/testpage/clients/ApiConsentClient.js';
import { wrapInSuspense } from '@src/testpage/components/helpers/wrapInSuspense.js';
import html from './MfeLifecycleSelect.html'; // eslint-disable-line no-restricted-imports

// Needs to be wrapped in <Suspense> because setup() is async
export const MfeLifecycleSelect = wrapInSuspense(defineComponent({
  name: 'MfeLifecycleSelect',
  components: {
    VAutocomplete,
  },
  template: html,
  props: {
    value: String,
  },
  emits: ['change'],
  async setup(props) {
    const lifecycle = ref<string>(props.value!);

    const apiConsentClient = await ApiConsentClient.create();
    const lifecycles = await apiConsentClient.get<string[]>('/service/lifecycles');

    return { lifecycles, lifecycle };
  },
}));
